const favButton  = $('div.gridItemFavButton');

favButton.unbind('click');
favButton.bind('click',function (e) {
    const $this = $(this);
    axios.get(e.target.getAttribute('data-url'))
        .then(function (response) {
            switch (response.data.type) {
                case 'removed':
                    $this.prop('title', 'Add favorite');
                    $this.text('Add favorite');
                    $this.removeClass('active');
                    break;
                case 'added':
                    $this.prop('title', 'Remove from favorite');
                    $this.text('Remove from favorite');
                    $this.addClass('active');
                    break;
            }
        })
        .catch(function (error) {
            console.error('Error favored: ' + error);
        })
    ;
});
